import type { paths } from '@pba/types-openapi-client';
import type { EventPrivacy, ProgramEventType } from 'models';
import { type ApiClientResponse, type EntityReferenceRailsRequestData, apiClient, routes } from 'common/services';
import type { EventContentObjectDataObject } from 'models/service';

export type AttendeesRequestData =
  paths['/v3/event_users/{id}']['patch']['requestBody']['content']['application/json']['event'];

export type DefaultProgramEventRequestData = {
  event_type: ProgramEventType;
  events_files?: EntityReferenceRailsRequestData[];
  featured_in_channels?: boolean;
  program_id?: string;
  program_topic_id?: string;
  publish_at?: Date;
  show_in_channels?: boolean;
  tag_ids?: string[];
  view_permission: EventPrivacy;
} & CommonProgramEventRequestData;

export type ProgramEventRequestData = DefaultProgramEventRequestData;

type CommonProgramEventRequestData = {
  allow_guest?: boolean;
  community_id?: string;
  cover_photo?: EntityReferenceRailsRequestData;
  duplicate_invitees_from?: string;
  end_time: Date;
  html_content?: string;
  name: string;
  start_time: Date;
  text_content?: string;
} & AttendeesRequestData;

export const createProgramEvent = async (event: ProgramEventRequestData) =>
  apiClient.post<EventContentObjectDataObject, ApiClientResponse<EventContentObjectDataObject>>(routes.events.create, {
    event,
  });
